import { action } from 'easy-peasy';

import { IActionSetDemographicsReport } from '../types';

const setDemographicsReport: IActionSetDemographicsReport = action((state, report) => {
  state.demographics.report = report;
});

export default setDemographicsReport;
